/* Cart drawer safety net: if the cart has items but the drawer is still showing its "cart is empty" message
   (stale drawer after add to cart), re-fetch the drawer fresh and replace it.
   Also pulses the header cart icon pink when the number of items in the cart goes up
   (once the cart drawer is closed, since the drawer covers the icon while open), keeps the icon pink
   while the cart has items, styles the free shipping bar in brand pink with a single shimmer,
   rewords its message, hides "View cart" and "You may also like" in the drawer, makes Checkout pink,
   tightens the drawer header and subtotal, and adds the express checkout buttons
   (Shop Pay, PayPal, Apple Pay / Google Pay) under it. */
(function () {
  if (window.__fpCartSync) return;
  window.__fpCartSync = 1;

  var running = false;
  var timers = [];

  function rootUrl() {
    return (window.theme && theme.routes && theme.routes.root_url) || '/';
  }
  function mini() {
    return document.querySelector('[id^="MiniCart-"]');
  }
  function showsEmpty() {
    var m = mini();
    return !!(m && m.querySelector('.drawer__empty') && !m.querySelector('[id^="CartDrawer-Item-"]'));
  }

  async function repair() {
    var m = mini();
    var d = document.getElementById('CartDrawer');
    var sec = d && d.getAttribute('data-section-id');
    if (!m || !sec) return;
    var res = await fetch(rootUrl() + '?section_id=' + encodeURIComponent(sec) + '&fp=' + Date.now(), { cache: 'no-store' });
    var src = new DOMParser().parseFromString(await res.text(), 'text/html').getElementById(m.id);
    if (src && src.querySelector('[id^="CartDrawer-Item-"]')) m.innerHTML = src.innerHTML;
  }

  async function check() {
    if (running) return;
    running = true;
    try {
      if (showsEmpty()) {
        var c = await (await fetch('/cart.js', { cache: 'no-store' })).json();
        if (c.item_count > 0) await repair();
      }
    } catch (e) {}
    running = false;
  }

  function schedule() {
    timers.forEach(clearTimeout);
    timers = [];
    [600, 1200, 2000, 3000, 4500, 6500, 9000, 13000].forEach(function (ms) {
      timers.push(setTimeout(check, ms));
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.product-form__submit, [name="add"], form[action*="/cart/add"] [type="submit"]')) schedule();
  }, true);
  ['ajaxProduct:added', 'cart:updated', 'cart:refresh'].forEach(function (n) {
    document.addEventListener(n, schedule);
  });

  /* ---- Cart icon pulse + free shipping bar styling + drawer buttons ---- */
  var css = document.createElement('style');
  css.textContent =
    '.cart-drawer-button.fp-has-cart .icon-cart{color:#ff0a89}' +
    '.cart-drawer-button.fp-pulse::after{content:"";position:absolute;left:50%;top:50%;width:44px;height:44px;margin:-22px 0 0 -22px;border-radius:50%;background:#ff0a89;opacity:0;pointer-events:none;animation:fpRing 1s ease-out 3}' +
    '.cart-drawer-button.fp-pulse .icon-cart{color:#ff0a89;animation:fpIcon .5s ease-in-out 4}' +
    '.cart-drawer-button.fp-pulse cart-count{animation:fpIcon .5s ease-in-out 4}' +
    '@keyframes fpRing{0%{transform:scale(.5);opacity:.55}100%{transform:scale(1.7);opacity:0}}' +
    '@keyframes fpIcon{0%,100%{transform:scale(1)}50%{transform:scale(1.25)}}' +
    '.free-shipping-bar progress-bar{background-color:rgba(255,10,137,.12) !important}' +
    '.free-shipping-bar progress-bar::before{background-color:#ff0a89 !important;background-image:linear-gradient(90deg,rgba(255,255,255,0) 0%,rgba(255,255,255,0) 40%,rgba(255,255,255,.55) 50%,rgba(255,255,255,0) 60%,rgba(255,255,255,0) 100%) !important;background-size:250% 100% !important;background-repeat:no-repeat;background-position:100% 0}' +
    '.cart-drawer[active] .free-shipping-bar progress-bar::before{animation:fpShine 1.6s ease-in-out .9s 1 both}' +
    '@keyframes fpShine{0%{background-position:100% 0}100%{background-position:0 0}}' +
    '.drawer__footer-buttons a[href="/cart"]{display:none !important}' +
    '.drawer__footer-buttons button[name="checkout"]{grid-column:1 / -1 !important}' +
    '.drawer__footer-buttons{row-gap:8px !important}' +
    '#CartDrawer .drawer__footer-buttons button[name="checkout"]{background-color:#ff0a89 !important;border-color:#ff0a89 !important;color:#fff !important;min-height:38px !important;height:38px !important;padding-top:0 !important;padding-bottom:0 !important;border-radius:100px !important}' +
    '#CartDrawer .drawer__footer-buttons button[name="checkout"] .btn-fill{background-color:#d6006f !important}' +
    '#CartDrawer .drawer__footer-bottom{row-gap:12px !important}' +
    '#CartDrawer .drawer__footer-bottom .tax-note{display:none !important}' +
    '#CartDrawer .drawer__footer-bottom > div.grid{grid-template-columns:1fr !important}' +
    '#CartDrawer .drawer__footer-bottom .totals{display:flex !important;justify-content:space-between !important;align-items:baseline !important;place-self:stretch !important;width:100%}' +
    '#CartDrawer .drawer__header{padding-top:20px !important;padding-bottom:8px !important}' +
    '#CartDrawer .drawer__tabs li{height:auto !important;min-height:0 !important}' +
    '.drawer__footer-buttons .fp-express{margin:0}' +
    '#CartDrawer product-recommendations.complementary-products{display:none !important}' +
    '#CartDrawer .fp-express shopify-accelerated-checkout-cart{--shopify-accelerated-checkout-button-block-size:38px !important;--shopify-accelerated-checkout-row-gap:6px !important;--shopify-accelerated-checkout-button-border-radius:100px !important}' +
    '@media (prefers-reduced-motion:reduce){.cart-drawer-button.fp-pulse::after,.cart-drawer-button.fp-pulse .icon-cart,.cart-drawer-button.fp-pulse cart-count{animation:none}.cart-drawer-button.fp-pulse .icon-cart{color:#ff0a89}.cart-drawer[active] .free-shipping-bar progress-bar::before{animation:none}}';
  document.head.appendChild(css);

  /* ---- Free shipping message wording ---- */
  var FS_TEXT = 'You’ve got free shipping 🎉';
  function rewordShipping(root) {
    var spans = (root || document).querySelectorAll('.free-shipping-bar > span');
    for (var i = 0; i < spans.length; i++) {
      var s = spans[i];
      if (/eligible for free shipping/i.test(s.textContent) && s.textContent.trim() !== FS_TEXT) s.textContent = FS_TEXT;
    }
  }

  /* ---- Express checkout buttons under Checkout in the cart drawer ---- */
  var expressHtml = '';
  var expressAt = 0;
  var expressBusy = false;
  var expressTried = 0;
  var expressRetry = 0;
  function getExpress() {
    if (expressHtml && Date.now() - expressAt < 300000) return Promise.resolve(expressHtml);
    return fetch(rootUrl() + '?section_id=fp-express-checkout&fp=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) {
        if (t && t.indexOf('additional-checkout-buttons') !== -1) { expressHtml = t; expressAt = Date.now(); return t; }
        return '';
      });
  }
  function injectExpress() {
    if (expressBusy) return;
    var forms = document.querySelectorAll('#CartDrawer .drawer__footer-buttons');
    var need = [];
    for (var i = 0; i < forms.length; i++) {
      if (!forms[i].querySelector('.fp-express')) need.push(forms[i]);
    }
    if (!need.length) return;
    if (!document.querySelector('#CartDrawer [id^="CartDrawer-Item-"]')) return;
    /* The 10 second cooldown only applies when the buttons have to be fetched again.
       When they are already cached, put them straight back (the drawer is rebuilt on
       every quantity change, which wipes them), and if a fetch has to wait, retry after it. */
    var cached = expressHtml && Date.now() - expressAt < 300000;
    if (!cached && Date.now() - expressTried < 10000) {
      if (!expressRetry) {
        expressRetry = setTimeout(function () { expressRetry = 0; injectExpress(); }, 10200);
      }
      return;
    }
    expressTried = Date.now();
    expressBusy = true;
    getExpress().then(function (t) {
      if (!t) return;
      var list = document.querySelectorAll('#CartDrawer .drawer__footer-buttons');
      for (var j = 0; j < list.length; j++) {
        var f = list[j];
        if (f.querySelector('.fp-express')) continue;
        var tmp = document.createElement('div');
        tmp.innerHTML = t;
        var src = tmp.querySelector('.additional-checkout-buttons');
        if (!src) continue;
        var wrap = document.createElement('div');
        wrap.className = 'fp-express col-span-full';
        wrap.appendChild(src);
        f.appendChild(wrap);
      }
    }).catch(function () {}).then(function () { expressBusy = false; });
  }

  rewordShipping();
  injectExpress();
  new MutationObserver(function () { rewordShipping(); injectExpress(); }).observe(document.documentElement, { childList: true, subtree: true });

  function countNow() {
    var el = document.querySelector('.cart-drawer-button cart-count');
    var n = el ? parseInt((el.textContent || '').replace(/\D/g, ''), 10) : 0;
    return isNaN(n) ? 0 : n;
  }
  function markCart() {
    var has = countNow() > 0;
    var btns = document.querySelectorAll('.cart-drawer-button');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].classList.contains('fp-has-cart') !== has) btns[i].classList.toggle('fp-has-cart', has);
    }
  }
  function drawerClosed() {
    var d = document.getElementById('CartDrawer');
    return !d || !d.hasAttribute('open');
  }
  function pulse() {
    var btns = document.querySelectorAll('.cart-drawer-button');
    for (var i = 0; i < btns.length; i++) {
      (function (b) {
        b.classList.remove('fp-pulse');
        void b.offsetWidth;
        b.classList.add('fp-pulse');
        setTimeout(function () { b.classList.remove('fp-pulse'); }, 2200);
      })(btns[i]);
    }
  }
  var waiting = false;
  function pulseWhenVisible() {
    if (waiting) return;
    waiting = true;
    var tries = 0;
    (function loop() {
      tries++;
      if (drawerClosed() || tries > 60) { waiting = false; pulse(); return; }
      setTimeout(loop, 400);
    })();
  }

  markCart();
  var last = countNow();
  setInterval(function () {
    var n = countNow();
    markCart();
    if (n > last) pulseWhenVisible();
    last = n;
  }, 400);
})();
